import slugify from "slugify";

import { IPlaylistDB } from "../../interfaces/Playlist";

class PlaylistManager {
  private Dictionary: Map<number, string> = new Map();

  public get(sourceId: number) {
    const exist = this.Dictionary.has(sourceId);

    if (!exist) return this.Dictionary.get(sourceId);

    return this.Dictionary.get(sourceId);
  }

  public async set(sourceId: number, track: IPlaylistDB) {
    // Una `source` que ya es una URI absoluta se guarda tal cual, en vez de

    // envolverla en un path eriol-workspace://artists/... (eso solo aplica a

    // las pistas de la biblioteca local, que persisten un nombre de archivo).

    // Las dos formas absolutas tienen camino de reproducción en

    // `PlaylistTrack.play`, y ninguna llega como URL cruda al <audio>: se

    // resuelven a un blob: (FilesService para eriol-workspace://, fetch+cache

    // para http(s)). Lo único que #737 se llevó fue el proxy local que envolvía

    // ese fetch — no el camino. Si el host remoto no manda CORS, PlaylistTrack

    // tira y `Playlist` salta a la pista siguiente.

    const src = track.source;

    if (
      typeof src === "string" &&
      (src.startsWith("eriol-workspace://") || /^https?:\/\//i.test(src))
    ) {
      this.Dictionary.set(sourceId, src);

      return;
    }

    if (!track.artist.name || !track.album.name) return;

    const artistSlug = track.artist?.slug ?? slugify(track.artist.name);

    const albumSlug = track.album?.slug ?? slugify(track.album.name);

    this.Dictionary.set(
      sourceId,

      `eriol-workspace://artists/${artistSlug}/albums/${albumSlug}/${track.source}`,
    );
  }

  destroy(sourceId: number) {
    const video = this.Dictionary.get(sourceId);

    if (video) {
      this.Dictionary.delete(sourceId);
    }
  }
}

export default new PlaylistManager();
